export const FETCH_SKU_CATEGORIES_REQUEST = '@sites/FETCH_SKU_CATEGORIES_REQUEST';
export const FETCH_SKU_CATEGORIES_SUCCESS = '@sites/FETCH_SKU_CATEGORIES_SUCCESS';
export const FETCH_SKU_CATEGORIES_FAILURE = '@sites/FETCH_SKU_CATEGORIES_FAILURE';

export const CREATE_AND_REFRESH_SKU_CATEGORY_REQUEST = '@sites/CREATE_SKU_CATEGORY_REQUEST';
export const CREATE_AND_REFRESH_SKU_CATEGORY_SUCCESS = '@sites/CREATE_SKU_CATEGORY_SUCCESS';
export const CREATE_AND_REFRESH_SKU_CATEGORY_FAILURE = '@sites/CREATE_SKU_CATEGORY_FAILURE';
